import React from "react";
import { Styled } from './styled'

interface DescriptionProps {
  icon?: string;
  title?: string;
  text?: any[];
}

const DescriptionCalls = (props: DescriptionProps) => {

  return (
    <Styled.Content>
      <img src={props.icon} alt='onpbx-icon' />
      <Styled.Title>{props.title}</Styled.Title>
      <Styled.List>
        {props.text.map((item) => (
          <Styled.Text>{item}</Styled.Text>
        ))}
      </Styled.List>
    </Styled.Content>
  )
}

export default DescriptionCalls
